// extracted by mini-css-extract-plugin
module.exports = {"teamsCase":"style_teamsCase__Klbh3","teamsCase__title":"style_teamsCase__title___ML_i"};